export default {
    methods: {
        number(value, max_decimals = 1) {
            return new Intl.NumberFormat(this.$i18n.locale, { maximumFractionDigits: max_decimals }).format(value)
        },
    },
}
